// Allowlist sanitizer for small rich-text fields stored as HTML.
// Goal: preserve simple formatting while preventing arbitrary HTML/XSS.
//
// Allowed tags: <b>, <i>, <u>, <h3>, <p>, <br>
// Disallowed tags are stripped; attributes are removed.

export function sanitizeLimitedHtml(input: unknown): string {
    if (input === null || input === undefined) return '';
    let s = String(input);
    if (!s) return '';

    // Normalize newlines early
    s = s.replace(/\r\n/g, '\n');

    // Common entity
    s = s.replaceAll('&nbsp;', ' ');

    // Normalize strong/em to b/i
    s = s.replace(/<\s*strong\b[^>]*>/gi, '<b>').replace(/<\s*\/\s*strong\s*>/gi, '</b>');
    s = s.replace(/<\s*em\b[^>]*>/gi, '<i>').replace(/<\s*\/\s*em\s*>/gi, '</i>');

    // Flatten block tags we don't want (div, li, ul, ol -> br)
    // But KEEP p and h3 as requested
    s = s
        .replace(/<\s*div\b[^>]*>/gi, '<br>')
        .replace(/<\s*\/\s*div\s*>/gi, '')
        .replace(/<\s*\/\s*li\s*>/gi, '<br>')
        .replace(/<\s*li\b[^>]*>/gi, '- ')
        .replace(/<\s*\/\s*ul\s*>/gi, '<br>')
        .replace(/<\s*ul\b[^>]*>/gi, '')
        .replace(/<\s*\/\s*ol\s*>/gi, '<br>')
        .replace(/<\s*ol\b[^>]*>/gi, '');

    // Strip generic Word/Office junk
    s = s.replace(/<(meta|link|style|xml|font|span|o:p)[^>]*>/gi, '');
    s = s.replace(/<\/(meta|link|style|xml|font|span|o:p)>/gi, '');

    // Strip all tags EXCEPT allowed ones (b, i, u, h3, p, br)
    // Regex explanation: Match < tag > that is NOT one of our allowed tags
    // allowed: b, i, u, h3, p, br
    s = s.replace(/<(?!\/?\s*(b|i|u|h3|p|br)\b)[^>]*>/gi, '');

    // Explicitly strip class and style attributes first (Safety layer)
    s = s.replace(/\s+(class|style)="[^"]*"/gi, '');
    s = s.replace(/\s+(class|style)='[^']*'/gi, '');

    // Remove ALL attributes from the allowed tags
    // e.g. <p class="MsoNormal"> -> <p>
    s = s.replace(/<([a-z0-9]+)\s+[^>]*>/gi, '<$1>');

    // Convert raw newlines to <br> if they aren't near block tags
    // (This is a simplified approach; usually we trust the HTML structure if allowing p/h3)
    // However, user might paste mixed content.
    // For now, let's trust the browser's "text/html" paste to provide structure,
    // and only convert \n if it's plainly there.
    // But be careful not to double break inside <p>.

    // Tidy repeated breaks - DISABLED (User requested manual spacing control)
    // s = s.replace(/(<br>\s*){3,}/gi, '<br><br>');

    // START/END TRIM - DISABLED (User reported "Ghost Rows" where they type enter and it disappears)
    // s = s.replace(/^\s*(<br>\s*)+/i, '');
    // s = s.replace(/(\s*<br>\s*)+$/i, '');

    return s.trim();
}
